import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PullToRefreshDirective } from '../directives/pull-to-refresh.directive';

@NgModule({
  declarations: [
    PullToRefreshDirective
  ],
  imports: [
    CommonModule
  ],
  exports: [
    CommonModule,
    PullToRefreshDirective
  ]
})
export class SharedModule { } 